import { Box, Center, Flex, Spinner, Text } from "@chakra-ui/react";

import BaseImage from "@components/BaseImage";
import FooterButtons from "./components/FooterButtons";

import { TransactionType } from "../../constants/types";
import { TransactionIconMapping } from "./utils";

interface SuccessErrorModalBodyTemplateProps {
  transactionType?: TransactionType;
  isSpinnerRequired?: boolean;
  modalTitle: string;
  modalSubTitle?: string;
  modalExtraText?: string;
  primaryBtnTxt?: string; // view transactions
  secondaryBtnTxt?: string; // close or cancel
  onSubmitPrimary?: () => void;
  onSubmitSecondary?: () => void;
}

const SuccessErrorModalBodyTemplate = ({
  isSpinnerRequired = false,
  transactionType,
  modalTitle,
  modalSubTitle,
  modalExtraText,
  primaryBtnTxt,
  secondaryBtnTxt,
  onSubmitPrimary,
  onSubmitSecondary,
}: SuccessErrorModalBodyTemplateProps) => {
  // const defaultOptions = {
  //   name: "animantion",
  //   loop: true,
  //   autoplay: true,
  //   renderer: "svg",
  //   animationData: loader_dark,
  // };

  return (
    <Center
      textAlign="center"
      flexDir="column"
      w={{ base: "100%", md: "400px" }}
      my={{ base: "24px", md: "48px" }}
      mx={{ base: "0", md: "24px" }}
      gap={{ base: "16px", md: "24px" }}
    >
      {isSpinnerRequired && (
        <Center h="160px" w="160px">
          <Spinner
            size="xl"
            thickness="4px"
            speed="0.75s"
            color="textPrimary"
          />
          {/* <Lottie options={defaultOptions} /> */}
        </Center>
      )}
      {transactionType && (
        <BaseImage
          src={TransactionIconMapping[transactionType].icon}
          width={64}
          height={64}
          alt="icon"
        />
      )}
      <Flex flexDir="column" gap="4px">
        <Text
          mt={isSpinnerRequired ? "1rem" : "0"}
          fontSize={{
            base: "20px",
            md: "24px",
          }}
          lineHeight="28px"
          color="#1A1A1A"
        >
          {modalTitle}
        </Text>
        {modalSubTitle && (
          <Text
            fontSize={{
              base: "12px",
              md: "14px",
            }}
            fontWeight="400"
            textAlign="center"
            color="#4A6A6A"
          >
            {modalSubTitle}
          </Text>
        )}
        {modalExtraText && (
          <Text
            mt="4px"
            fontSize={{
              base: "12px",
              md: "14px",
            }}
            fontWeight="400"
            textAlign="center"
            color="textSecondary"
          >
            {modalExtraText}
          </Text>
        )}
      </Flex>
      {primaryBtnTxt || secondaryBtnTxt ? (
        <Box>
          <FooterButtons
            secondaryBtnTxt={secondaryBtnTxt}
            onSubmitSecondary={onSubmitSecondary}
            primaryBtnTxt={primaryBtnTxt}
            onSubmitPrimary={onSubmitPrimary}
          />
        </Box>
      ) : null}
    </Center>
  );
};

export default SuccessErrorModalBodyTemplate;
